module.exports = __webpack_public_path__ + "img/fig4.ce625320.png";